import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=672b7274&scoped=true&"
import script from "./Shop.vue?vue&type=script&lang=ts&"
export * from "./Shop.vue?vue&type=script&lang=ts&"
import style0 from "./Shop.vue?vue&type=style&index=0&id=672b7274&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b7274",
  null
  
)

export default component.exports